import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { CloseIcon } from './Styles/Icons';
import { Bold, ButtonGroup, Button, FlexRow, Dialog, DialogActions, DialogTitle, DialogContent, CircularButton, ButtonWithLoader } from './Styles/DownloadOrderItems';

import { downloadOrderItems } from '../../actions/ordersActions';

const DownloadOrderItems = ({ open, filters, downloadOrderItems, onTrue, onFalse }) => {
	const [downloadingFile, setDownloadingFile] = useState(false);
	const [error, setError] = useState(null);

	const onTrueHandler = async () => {
		setDownloadingFile(true);
		let { searchText, dateRange, status, dso, custId } = filters;

		let errorState = {};
		setError(errorState);

		if (Object.keys(errorState).length) {
			setError(errorState);
		} else {
			await downloadOrderItems(
				'download-order-items',
				status && status.value,
				dateRange[0] ? moment(dateRange[0]).format('YYYY-MM-DD') : null,
				dateRange[1] ? moment(dateRange[1]).format('YYYY-MM-DD') : null,
				custId,
				dso && dso.value,
				searchText
			);
			await onTrue();
		}
		setDownloadingFile(false);
	};

	const onFalseHandler = async () => {
		await onFalse();
	};

	useEffect(() => {
		setError(null);
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => (downloadingFile ? null : onFalseHandler())}
			fullWidth
		>
			<DialogTitle>
                Download Orders
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						disabled={downloadingFile}
						onClick={() => onFalseHandler()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ marginTop: '-16px' }}>
				<FlexRow>Download orders with the following filters applied:</FlexRow>

				<FlexRow style={{ margin: '0.5rem 0' }}>
					<ul style={{ fontWeight: 'bold' }}>
						{filters.searchText ? (
							<li>
								Search: <Bold>{filters.searchText}</Bold>
							</li>
						) : null}
						{filters.dateRange && filters.dateRange[0] && filters.dateRange[1] ? (
							<li>
								Date Range:{' '}
								<Bold>{`${filters.dateRange[0].toLocaleString('default', { month: 'short' })} ${filters.dateRange[0].getDate()} - ${filters.dateRange[1].toLocaleString('default', {
									month: 'short',
								})} ${filters.dateRange[1].getDate()}`}</Bold>
							</li>
						) : null}
						{filters.status && filters.status.value ? (
							<li>
								Status: <Bold>{filters.status.label}</Bold>
							</li>
						) : null}
						{filters.dso && filters.dso.value ? (
							<li>
								Group: <Bold>{filters.dso.label}</Bold>
							</li>
						) : null}
					</ul>
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						disabled={downloadingFile}
						onClick={(e) => onFalseHandler()}
					>
						Cancel
					</Button>
					<ButtonWithLoader
						primary
						loading={downloadingFile}
						onClick={(e) => onTrueHandler()}
					>
						Download
					</ButtonWithLoader>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	downloadOrderItems,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DownloadOrderItems);
